<template>
  <div class="container mx-auto p-4 max-w-4xl">
    <h1 class="text-3xl font-bold mb-8 text-gray-800">
      <i class="fas fa-question-circle mr-2 text-primary"></i>
      使用帮助
    </h1>

    <div class="space-y-8">
       <!-- 下载安装 -->
      <section class="card p-6 bg-white rounded-xl shadow-sm mb-6">
        <h2 class="text-xl font-semibold mb-6 text-gray-800 flex items-center">
          <i class="fas fa-download mr-2 text-secondary"></i>
          下载安装
        </h2>
        
        <div class="mb-8 p-4 border border-gray-100 rounded-lg bg-blue-50">
          <h3 class="font-medium text-lg mb-3 text-blue-700">方法一：浏览器插件中心安装</h3>
          <p class="text-gray-600 mb-3">您可以在浏览器插件中心搜索“喵记”，进行安装。</p>
          <img src="https://file.miaoji360.top/wx/help1.png" class="rounded-md shadow-sm" />
        </div>
        
        <div class="p-4 border border-gray-100 rounded-lg bg-green-50">
          <h3 class="font-medium text-lg mb-3 text-green-700">方法二：直接下载安装</h3>
          <p class="text-gray-600 mb-4">直接下载插件进行解压安装</p>
          <a href="https://file.miaoji360.top/miaoji360.zip" class="inline-block px-6 py-3 bg-green-600 text-white font-medium rounded-md shadow-sm hover:bg-green-700 transition-colors duration-200" download>
            立即下载插件
          </a>
          <p class="mt-2 text-sm text-gray-500">安装方法：1.解压缩安装包</p>
          <p class="mt-2 text-sm text-gray-500">2.打开浏览器的开发者模式</p>
          <img src="https://file.miaoji360.top/wx/help2.png" class="mt-4 rounded-md shadow-sm" />
          <p class="mt-2 text-sm text-gray-500">3.点击加载解压缩的扩展</p>
          <img src="https://file.miaoji360.top/wx/help2.png" class="mt-4 rounded-md shadow-sm" />
          <p class="mt-2 text-sm text-gray-500">4.选择固定到工具栏，方便后续使用</p>
          <img src="https://file.miaoji360.top/wx/help2.png" class="mt-4 rounded-md shadow-sm" />
        </div>
      </section>

      <!-- 功能特点 -->
      <section class="card p-6 bg-white rounded-xl shadow-sm">
        <h2 class="text-xl font-semibold mb-4 text-gray-800">
          <i class="fas fa-book mr-2 text-secondary"></i>
          功能特点
        </h2>
        <div class="space-y-4 text-gray-600">
          <h3 class="font-medium text-gray-800 mb-2">浏览器插件-网站-微信小程序，三端融合</h3>
          <p>登录之后，在浏览器中可方便的进行画词翻译，保存，收藏网站，以及页面截图收藏等功能</p>
          <img src="https://file.miaoji360.top/wx/help2.png" />
          <p>系统会根据算法，对需要复习的内容进行复习提示</p>
          <p>您可以微信搜索小程序“喵记”，打开小程序及时查看复习</p>
          <p>也欢迎登录喵记网站<a>https://www.miaoji360.top/</a>查看服务</p>
        </div>
      </section>
     
      <!-- 基本使用 -->
      <section class="card p-6 bg-white rounded-xl shadow-sm">
        <h2 class="text-xl font-semibold mb-4 text-gray-800">
          <i class="fas fa-book mr-2 text-secondary"></i>
          基本使用
        </h2>
        <div class="space-y-4 text-gray-600">
          <div>
            <h3 class="font-medium text-gray-800 mb-2">创建笔记</h3>
            <p>点击首页的"添加笔记"按钮，输入笔记内容。建议将知识点分解为问答形式，便于后续复习。</p>
          </div>
          <div>
            <h3 class="font-medium text-gray-800 mb-2">复习笔记</h3>
            <p>系统会根据艾宾浩斯遗忘曲线安排复习计划。每天登录查看"今日待复习"，完成当天的复习任务。</p>
          </div>
        </div>
      </section>

      <!-- 间隔复习 -->
      <section class="card p-6 bg-white rounded-xl shadow-sm">
        <h2 class="text-xl font-semibold mb-4 text-gray-800">
          <i class="fas fa-clock mr-2 text-warning"></i>
          间隔复习说明
        </h2>
        <div class="space-y-4 text-gray-600">
          <p>系统采用 SuperMemo SM-2 算法，根据你的复习表现动态调整复习间隔：</p>
          <ul class="list-disc pl-5 space-y-2">
            <li>评分越高，下次复习间隔越长</li>
            <li>评分越低，间隔会相应缩短</li>
            <li>连续高分会显著增加间隔时间</li>
            <li>建议每天保持复习习惯，避免积压</li>
          </ul>
        </div>
      </section>

      <!-- 使用建议 -->
      <section class="card p-6 bg-white rounded-xl shadow-sm">
        <h2 class="text-xl font-semibold mb-4 text-gray-800">
          <i class="fas fa-lightbulb mr-2 text-success"></i>
          使用建议
        </h2>
        <div class="space-y-4 text-gray-600">
          <ul class="list-disc pl-5 space-y-2">
            <li>保持每天复习的习惯，避免积压太多待复习内容</li>
            <li>诚实评价自己的复习质量，这会帮助系统更好地为你安排复习计划</li>
            <li>如果发现某类内容总是难以记住，可以适当降低间隔系数</li>
            <li>定期查看记忆效率统计，及时调整学习策略</li>
          </ul>
        </div>
      </section>
    </div>
  </div>
</template>